module.exports = __webpack_public_path__ + "img/lg_ring_g_0_0_1@3x.015b256e.png";